<template>
  <div>
    <v-col>
      <v-row no-gutters>
        <v-col cols="auto">
          <span class="pl-5 filter_text">Credentials ID:</span>
        </v-col>
        <v-spacer />

        <v-col cols="auto">
          <v-text-field
          id="filter_cred_ids"
            v-model="creds_id_filter"
            outlined
            clearable
            dense
            @change="
              $emit('build_filter', {
                field: 'credentials_id',
                value: creds_id_filter,
              })
            "
            @click:clear="
              $emit('build_filter', {
                field: 'credentials_id',
                value: null,
              })
            "
          ></v-text-field>
        </v-col>
      </v-row>
      <v-spacer></v-spacer>
      <v-row no-gutters>
        <v-col cols="auto">
          <span class="pl-5 filter_text">Description:</span>
        </v-col>
        <v-spacer />

        <v-col cols="auto">
          <v-text-field
            id="filter_description"
            v-model="description_filter"
            outlined
            clearable
            dense
            @change="
              $emit('build_filter', {
                field: 'description',
                value: description_filter,
              })
            "
            @click:clear="
              $emit('build_filter', {
                field: 'description',
                value: null,
              })
            "
          ></v-text-field>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>
<script>
export default {
  data() {
    return {
      creds_id_filter: null,
      description_filter: null,
    };
  },
  mounted() {
    this.syncFilters();
  },
  watch: {
    $route() {
      this.syncFilters();
    },
  },
  methods: {
    syncFilters() {
      // filters list with one item returns a string, cast to array
      let filters = this.$route.query.filters || [];
      this.$route.query.filters =
        typeof filters == "string" ? [filters] : filters;

      var creds_id = "credentials_id";
      var description = "description";

      this.creds_id_filter = null;
      this.description_filter = null;

      this.$route.query.filters.forEach((element) => {
        if (element.startsWith(creds_id)) {
          this.creds_id_filter = element.substring(creds_id.length + 1);
        }
        if (element.startsWith(description)) {
          this.description_filter = element.substring(description.length + 1);
        }
      });
    },
  },
};
</script>
<style scoped>
.v-text-field {
  max-width: 185px;
}
</style>
